
import {appendHashToUrl} from '@util/URLUtils';
import {menuItemMedia} from '../../styles';

const MediaItem = ( {title, brandShortDescription, image = {}, url, urlHash} ) => {
    return (
        <li>
            <a className={menuItemMedia.root} href={appendHashToUrl( url, urlHash )}>
                {image &&
                <div className={menuItemMedia.left}>
                    <div className={menuItemMedia.thumbnailWrap}>
                        <img
                            width="64"
                            data-src={`${image.source}?w=128`}
                            alt={image.alt}
                            className={menuItemMedia.thumbnail}/>
                    </div>
                </div>
                }
                <div className={menuItemMedia.right}>
                    <h4 className={menuItemMedia.title}>{title}</h4>
                    <p className={menuItemMedia.detail}>{brandShortDescription}</p>
                </div>
            </a>
        </li>
    );
};

export default MediaItem;